// Copyright ©️ 2026 eVolve MEP, LLC

import type { WorkCellTaskType } from '@evolvemep/api-ts';
import { ActionIcon } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';

import { useWorkCellSetupModals } from './modalRegistries';

type Props = {
  workCellTaskType: WorkCellTaskType;
  onWorkCellTaskTypeUnassigned: () => void;
};

export const UnassignTaskTypeButton = ({ workCellTaskType, onWorkCellTaskTypeUnassigned }: Props) => {
  const { openModal } = useWorkCellSetupModals();
  return (
    <ActionIcon
      color="gray"
      onClick={() => openModal('unassignTaskTypeModal', { workCellTaskType, onWorkCellTaskTypeUnassigned })}
      variant="transparent"
    >
      <EvolveIcon icon="Unpin" color="inherit" size="sm" className="show-on-row-hover" />
    </ActionIcon>
  );
};
